export default __webpack_public_path__ + "static/media/130.459a7408.svg";